import { z } from 'zod';

export const StartAutomappingRequestSchema = z.object({
  platformId: z.string().optional(),
  platformName: z.string().optional(),
  mediaRowId: z.string().nullable().optional(),
  taxonomyAdGroupExternalId: z.string().nullable().optional(),
  taxonomyAdGroupId: z.string().nullable().optional(),
  taxonomyAdExternalId: z.string().nullable().optional(),
  taxonomyAdId: z.string().nullable().optional(),
  taxonomyCampaignExternalId: z.string().nullable().optional(),
  taxonomyCampaignId: z.string().nullable().optional(),
  taxonomyCampaignSubtype: z.string().nullable().optional(),
});

export type StartAutomappingRequest = z.infer<
  typeof StartAutomappingRequestSchema
>;
